import { GlobalStyles, RTL } from './core/styles';

import AdapterJalali from '@date-io/date-fns-jalali';
import { LocalizationProvider } from '@mui/lab';
import { CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';
import { Authorization } from './components/authorization';
import { DefaultSuspenseFallback } from './components/suspense-fallback';
import { AppThemeProvider } from './core/context';
import { queryClient } from './core/react-query';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<DefaultSuspenseFallback fullPage />}>
        <HelmetProvider>
          <RTL>
            <AppThemeProvider>
              <GlobalStyles />
              <SnackbarProvider>
                <CssBaseline />
                <BrowserRouter>
                  <Authorization>
                    {/* Make the date adaptor dynamic */}
                    <LocalizationProvider dateAdapter={AdapterJalali}>
                      <AppRouter />
                    </LocalizationProvider>
                  </Authorization>
                </BrowserRouter>
              </SnackbarProvider>
            </AppThemeProvider>
          </RTL>
        </HelmetProvider>
      </Suspense>
    </QueryClientProvider>
  );
}

export default App;
